<template>
  <div class="address-panel">
    <div class="address-panel-component hidden">
      <div class="component-background" @click="close" />
      <div
        class="wrapper no-scrollbar"
        :class="theme"
        style="overflow: scroll"
        :key="z"
      >
        <div v-if="!isEditing">
          <toggle-button
            v-if="$store.getters.isSuperUser || allowSpoof"
            class="is-pulled-right"
            style="top: 0px"
            :value="isFakeGPS"
            color="red"
            :sync="true"
            :labels="{ checked: $t('FAKE'), unchecked: $t('REAL') }"
            :height="25"
            :width="60"
            @change="spoofGPS($event.value)"
          />
          <p
            class="important-locations has-text-grey"
            @click="spoofCounter += 1"
          >
            {{ $t("address.important-locations") }}
          </p>
          <div class="columns is-mobile">
            <div class="column is-narrow">
              <img src="/img/home2/meerkat.svg" class="wiggle" />
            </div>
            <div class="column has-text-left">
              <i
                class="fa fa-crosshairs fa-lg has-text-info is-pulled-right"
                :class="{ 'fa-spin': spin }"
                @click="init"
              />
              <p
                class="has-text-weight-medium has-text-info"
                @click="changeRegion"
              >
                {{ $t("address.current") }}:&nbsp;
                <span class="link">{{ $store.state.region }}</span>
              </p>
              <p @click="showCurrentLocation">{{ currentStreet || "..." }}</p>
            </div>
          </div>
          <div v-for="(a, i) in addresses" :key="a.id">
            <div class="columns is-mobile">
              <div class="column is-narrow" @click="setFakeGPSLocation(a)">
                <img :src="svgs[i]" class="wiggle" />
              </div>
              <div class="column has-text-left" @click="edit(a)">
                <p class="has-text-weight-medium">
                  {{ translateAddressType(a.address_type) }}
                  <!-- <i class="fa fa-pencil-alt has-text-info is-pulled-right" /> -->
                </p>
                <p class="clamp">{{ a.name }}</p>
              </div>
            </div>
          </div>

          <zoom-y-transition group>
            <div
              v-if="!showNewAddress"
              key="1"
              class="mt-12"
              @click="showNew(true)"
            >
              <span class="link">Add a location</span>
            </div>
            <div v-else key="2" class="mt-12">
              <span @click="showNew(false)">
                <i class="fa fa-chevron-left" />&nbsp;
                <span>{{ $t("address.add-new") }}</span>
              </span>

              <div style="margin-top: 8px; margin-bottom: 10px">
                <span class="buttons is-centered single-line">
                  <a
                    class="button is-rounded is-outlined"
                    @click="newAddress('home')"
                    >{{ $t("address.home") }}</a
                  >
                  <a
                    class="button is-rounded is-outlined"
                    @click="newAddress('work')"
                    >{{ $t("address.work") }}</a
                  >
                  <a
                    class="button is-rounded is-outlined"
                    @click="newAddress('delivery')"
                    >{{ $t("address.delivery") }}</a
                  >
                  <a
                    class="button is-rounded is-outlined"
                    @click="newAddress('other')"
                    >{{ $t("address.other") }}</a
                  >
                </span>
              </div>
            </div>
          </zoom-y-transition>
        </div>

        <!-- Editing -->
        <div v-else>
          <p class="subtitle has-text-left" style="margin-bottom: 10px">
            <!-- <img src="/img/home2/meerkat.svg" style="height: 30px; position: relative; top: 5px; margin-right: 5px;" /> -->
            <span @click="address = null">
              <i class="fa fa-chevron-left" style="margin-right: 8px" />
              {{ translateAddressType(address.address_type) }}
              <span>{{ $t("address.address") }}</span>
            </span>
            <span
              class="
                is-pulled-right
                button
                is-small is-danger is-outlined is-rounded
              "
              style="padding: 9px"
            >
              <i class="far fa-trash-alt" @click="preDelete" />
            </span>
          </p>
          <div class="columns is-mobile">
            <div class="column has-text-left">
              <p v-if="googleMapURL" style="margin-bottom: 6px">
                <a :href="googleMapURL" target="_blank">
                  <i class="fa fa-map-marker-alt has-text-grey" />
                  {{ $t("address.see-on-map") }}
                  <i class="fa fa-external-link-alt fa-sm" />
                </a>
                <!-- <i
                  class="fa fa-globe-asia fa-lg has-text-info is-pulled-right"
                  style="padding: 4px" 
                /> -->
                <span
                  class="link is-pulled-right has-text-grey"
                  style="font-size: 0.85em; font-weight: 500"
                  @click="openSetAddressModal"
                  >Edit location</span
                >
              </p>
              <p v-else class="has-text-centered">
                <span
                  class="button is-light is-rounded pulse"
                  @click="openSetAddressModal"
                >
                  <i class="fa fa-map-marker-alt" />
                  &nbsp;{{ $t("address.set-location") }}
                </span>
              </p>

              <span class="label">{{ $t("address.short-name") }}</span>
              <p class="editable" @click="editField('name')">
                <!-- {{ address.name || namePlaceholder }} -->
                <span v-if="address.name">{{ address.name }}</span>
                <span v-else>
                  <i>{{ $t("address.enter-name") }}</i>
                </span>
                <i class="fa fa-pencil-alt has-text-info is-pulled-right" />
              </p>
              <span class="label">{{ $t("address.address") }}</span>
              <p class="editable" @click="editField('address')">
                <!-- {{ address.address || addressPlaceholder }} -->
                <span v-if="address.address">{{ address.address }}</span>
                <span v-else>
                  <i>{{ $t("address.enter-address") }}</i>
                </span>
                <i class="fa fa-pencil-alt has-text-info is-pulled-right" />
              </p>
              <span class="label">{{ $t("address.notes") }}</span>
              <p class="editable" @click="editField('notes')">
                <!-- {{ address.notes || notesPlaceholder }} -->
                <span v-if="address.notes">{{ address.notes }}</span>
                <span v-else>
                  <i>{{ $t("address.enter-notes") }}</i>
                </span>
                <i class="fa fa-pencil-alt has-text-info is-pulled-right" />
              </p>
            </div>
          </div>
          <!-- <a
            class="button is-white is-rounded"
            style="padding: 0 12px"
            @click="address = null"
          >
            <i class="fa fa-chevron-left" /> </a
          >&nbsp; -->
          <p
            class="button is-rounded is-outlined is-success"
            style="margin-top: 6px"
            @click="preSave"
          >
            {{ $t("save") }}
          </p>
        </div>

        <span v-show="isUpdating" class="close is-pulled-left">
          <i class="fa fa-spinner fa-lg fa-spin" />
        </span>
        <span class="close is-pulled-right">
          <i class="fa fa-chevron-up fa-lg" @click="close" />
        </span>
      </div>
    </div>

    <!-- <QRCodeGenerator /> -->
  </div>
</template>

<script>
import EventBus from "../eventBus.js";
import geo from "@/geo";
import { sounds } from "../functions.js";

// import QRCodeGenerator from "@/components/QRCodeGenerator.vue";

export default {
  name: "AddressPanel",
  components: {
    // QRCodeGenerator
  },
  data() {
    return {
      showNewAddress: false,
      currentStreet: null,
      spin: false,
      isUpdating: false,
      address: null,
      addressCallback: "ADDRESS_PANEL_CALLBACK",
      isFakeGPS: false,
      spoofCounter: 0, // allows non-superuser to access GPS spoofing
      z: 0,
      svgs: [
        // meerkat is used by current location
        "/img/home2/bird.svg",
        "/img/home2/deer.svg",
        "/img/home2/squirrel.svg",
        "/img/home2/rabbit.svg",
      ],
    };
  },
  computed: {
    theme() {
      return this.$store.state.theme;
    },
    addresses() {
      return this.$store.getters.getAddresses;
    },
    isSuper() {
      return this.$store.getters.isSuperUser;
    },
    isEditing() {
      return this.address;
    },
    namePlaceholder() {
      // return "✏️ " + this.$t("address.enter-name");
      return this.$t("address.enter-name");
    },
    addressPlaceholder() {
      return "✏️ " + this.$t("address.enter-address");
    },
    notesPlaceholder() {
      return "✏️ " + this.$t("address.enter-notes");
    },
    googleMapURL() {
      console.log("z", this.z);
      if (!this.address || !this.address.lat) return null;
      var a = this.address;
      return `http://www.google.com/maps/place/${a.lat},${a.lon}`;
    },
    allowSpoof() {
      if (this.spoofCounter > 4 || this.$store.state.fakeGPS) {
        return true;
      }
      return false;
    },
  },
  mounted() {
    this.isFakeGPS = this.$store.state.fakeGPS;
    if (this.isFakeGPS) this.startFakeGPS();
    EventBus.$on("OPEN_ADDRESS_PANEL", () => {
      this.init();
    });
    EventBus.$on(this.addressCallback, (data) => {
      console.log(this.addressCallback, data);
      this.address.lat = data.lat;
      this.address.lon = data.lon;
      this.address.name = data.name;
      this.address.address = data.address;
      this.forceUpdate();
    });
    EventBus.$on("ADDRESSES_LOADER", (state) => {
      this.isUpdating = state;
    });
    EventBus.$on("CLOSE_HOME_PANELS", () => this.close());
  },
  methods: {
    close() {
      this.showNewAddress = false;
      this.address = null;
      this.hideComponent(".address-panel-component");
    },
    changeRegion() {
      this.updateLocation();
      EventBus.$emit("OPEN_REGION_MODAL");
    },
    spoofGPS(fake) {
      sounds("navigate1");
      this.$store.commit("clearTimestamp", "welcomeTo"); // allow welcome to message to show
      console.log("spoofGPS", fake);
      this.isFakeGPS = fake;
      this.$store.commit("setFakeGPS", fake);
      if (fake) this.startFakeGPS();
      else this.stopFakeGPS();
      setTimeout(() => this.init(), 600);
    },
    setFakeGPSLocation(a) {
      if (!this.isSuperUser() && !this.allowSpoof) return;
      var obj = {
        coords: { latitude: a.lat, longitude: a.lon, accuracy: 1 },
      };
      this.$store.commit("setFakeGPSLocation", obj);
      if (this.isFakeGPS) {
        this.startFakeGPS();
        sounds("success");
      } else {
        sounds("unsafe");
      }
      setTimeout(() => this.init(), 600);
    },
    showCurrentLocation() {
      var coords = this.$store.state.userState;
      if (!coords) return;
      var googleMapURL = `http://www.google.com/maps/place/${coords.lat},${coords.lon}`;
      window.open(googleMapURL, "_blank");
    },
    showNew(state) {
      this.showNewAddress = state;
      if (this.showNewAddress) {
        // scroll to bottom
        var div = this.$el.querySelector(".wrapper");
        this.$nextTick(() => (div.scrollTop = div.scrollHeight));
        setTimeout(() => (div.scrollTop = div.scrollHeight), 300);
      }
    },
    forceUpdate() {
      this.$nextTick(() => (this.z += 1));
    },
    init() {
      this.updateAddresses();
      this.updateLocation();
      this.lookupStreet();
      this.city = geo.getRegion(this.$store.state.userState); // Chiang Mai, Bangkok, etc.
      this.$store.commit("setRegion", this.city); // should do this on every page
    },
    openSetAddressModal() {
      // maybe pass in optional country code
      // this.$nextTick(() => {
      console.log("openSetAddressModal");
      // this.displayModal(".set-address-modal");
      EventBus.$emit("SET_ADDRESS_MODAL", this.addressCallback);
      // });
    },
    edit(a) {
      this.address = a;
    },
    preSave() {
      if (!this.address || !this.address.lat || !this.address.name) {
        var msg = `Please set a location and name.`;
        return this.warningAlert(msg);
      }
      this.save();
    },
    save() {
      this.console("saveAddress", this.address);
      var loader = this.loadingDots("navy");
      this.$store
        .dispatch("saveUserAddress", this.address)
        .then(() => {
          this.updateAddresses();
          this.address = null;
        })
        .catch((err) => this.apiError(err))
        .finally(() => loader.hide());
    },
    preDelete() {
      this.$swal({
        title: `<i class='fa fa-trash-alt' style='color:red'></i>`,
        html: `Are you sure you want to delete this address?`,
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonColor: this.bulmaColor("danger"),
        cancelButtonColor: this.bulmaColor("success"),
        confirmButtonText: "Delete it",
        cancelButtonText: "Keep it",
      }).then((val) => {
        if (val.value) this.softDelete();
      });
    },
    softDelete() {
      // soft delete
      var loader = this.loadingDots("red");
      this.$store
        .dispatch("deleteUserAddress", this.address.id)
        .then(() => {
          this.updateAddresses();
          this.address = null;
        })
        .catch((err) => this.apiError(err))
        .finally(() => loader.hide());
    },
    newAddress(type) {
      this.showNewAddress = false;
      this.openSetAddressModal();
      this.address = {
        user_id: this.userID(),
        address_type: type,
      };
    },
    editField(field) {
      console.log("editing", field);
      var green = this.bulmaColor("success");
      var title = this.$t(`address.${field}`);
      var text = this.$t("address.please-enter-text");
      this.$swal({
        title: `<i class='fa fa-pencil-alt' style='color:${green}'></i>`,
        html: `<strong>${title}</strong><br>${text}`,
        input: "textarea",
        inputValue: this.address[field] || "",
        showCloseButton: true,
        confirmButtonText: this.$t("okay"),
        confirmButtonColor: green,
        inputValidator: (txt) => {
          this.address[field] = txt;
          //   this.save();
          this.forceUpdate();
          return null;
        },
      });
    },
    lookupStreet() {
      this.spin = true;
      var coords = this.$store.getters.getUserLocation;
      if (!coords) return; // no location available
      coords = { lat: coords[0], lon: coords[1] };
      this.$store
        .dispatch("reverseGeocode", coords)
        .then((res) => {
          this.console("reverseGeocode", res);
          //   this.addressName = res.data.address.road;
          this.currentStreet = res.data.address.road;
        })
        .catch((err) => console.error("lookupStreet", err))
        .finally(() => (this.spin = false));
    },
  },
};
</script>

<style scoped>
.hidden {
  display: none;
}
.important-locations {
  text-align: left;
  margin-bottom: 10px;
}
.component-background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.25);
  z-index: 2;
}
.wrapper {
  position: absolute;
  top: 0px;
  width: 100vw;
  max-height: 75vh;
  overflow: scroll;
  backdrop-filter: blur(8px);
  background-color: rgba(255, 255, 255, 0.85);
  /* background-color: #333;
  color: white; */
  padding: 12px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.35);
  z-index: 4;
  /* display: none; */
  /* border-bottom-right-radius: 25px;
  border-bottom-left-radius: 25px; */
}
.subtitle {
  color: #999;
}
.dark {
  /* background-color: rgba(17, 34, 51, 0.85); */
  background-color: #333;
  color: white;
}
.column {
  display: inline-block;
  /* padding: 0 0;
  margin-bottom: 10px; */
}
.column img {
  height: 40px;
}
.close {
  /* position: absolute;
  right: 0;
  bottom: 0; 
  padding: 6px;
  margin-right: 12px;*/
  position: absolute;
  bottom: 10px;
  right: 12px;
}
.toggle {
  position: absolute;
  right: 0;
  bottom: 0;
  padding: 6px;
  opacity: 0.5;
}
.toggle img {
  height: 22px;
}
.add {
  margin-top: -10px;
  margin-bottom: -15px;
  /* margin-bottom: -20px; */
}
.columns {
  margin: 0;
  margin-bottom: 4px;
  border: 1px solid rgba(255, 255, 255, 0.29);
  border-radius: 4px;
  box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.2);
}
.buttons .button {
  padding: 0 9px;
  margin-bottom: 0;
}
.no-scrollbar::-webkit-scrollbar {
  display: none;
}
.clamp {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1; /* clamp ellipsis single line */
  -webkit-box-orient: vertical;
  padding-right: 4px;
}
.editable {
  background-color: #f5d25258;
  border-radius: 6px;
  padding: 4px;
  margin-bottom: 6px;
}
.wiggle:active {
  transform: rotate(330deg);
  -webkit-transform: rotate(330deg);
  -ms-transform: rotate(330deg);
}
.pulse {
  animation: shadow-pulse 1s infinite;
}
@keyframes shadow-pulse {
  0% {
    box-shadow: 0 0 0 0px cyan;
  }
  100% {
    box-shadow: 0 0 0 6px rgba(0, 255, 255, 0.5);
  }
}
i {
  opacity: 0.7;
}
.label {
  margin-bottom: 0;
  font-weight: 450;
  color: #999;

  font-size: 0.9em;
}
.fa-pencil-alt {
  margin-top: 3px;
}
.mt-12 {
  margin-top: 12px;
}
</style>